import React, { useState, useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
import AllServices from "../../Services/AllServices";
import { toast } from "react-toastify";
import "./webDashboardsStep.scss";
import CustomLoaderBoxy from "../CustomLoader/CustomLoaderBoxy";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import state_List from "../../Constants/state_list.json";
import country_List from "../../Constants/country_list.json";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import {
  guestType,
  ImageBaseURLServer,
  Italy_Country_Code,
} from "../../Constants/Constants";
import WpConfirmationTable from "../WpConfirmationTable/WpConfirmationTable";

const imageBaseURL = ImageBaseURLServer;
const combineList = [...country_List, ...state_List];

const WpDashboardStep = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const [tabledata, setTableData] = useState([]);
  const [mainGuest, setMainGuest] = useState({
    refNumber: state.refNumber,
    famType: state.famType,
    stayDays: state.stayDays,
    placeOfBirth: state.placeOfBirth,
    docType: state.docType,
    NumberDoc: state.docNumber,
    docIssuingPlace: state.docIssuingPlace,
    arrivingDate: "",
    firstName: "",
    lastName: "",
    sex: "",
    dob: "",
    provinceCode: state.provinceCode,
    birthState: state.birthState,
    citizen: state.citizen,
  });

  const [childGuest, setChildGuest] = useState([]);
  const [data, setData] = useState({});
  const [stayDays, setStayDays] = useState("");
  const [arrivingdate, setArrivingData] = useState(null);
  const [childFile, setChildFile] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [storeData, setStoreData] = useState([]);
  const [openCitizenRow, setOpenCitizenRow] = useState(null);
  const [rowErrors, setRowErrors] = useState({});

  const guestypeCode = mainGuest.famType;
  const guest = guestType.find((item) => item.ID === guestypeCode);
  const guestTypeName = guest.name;

  const resolveBirthState = (placeOfBirth) => {
    const exists = country_List.some(
      (country) => country.code === placeOfBirth,
    );

    return exists ? placeOfBirth : Italy_Country_Code;
  };

  const validateRow = (row, index) => {
    const errors = {
      citizen: !row.citizen,
      placeOfBirth: !row.placeOfBirth,
    };

    setRowErrors((prev) => ({
      ...prev,
      [index]: errors,
    }));

    return !errors.citizen && !errors.placeOfBirth;
  };

  const handleBirthPlaceChange = (rowIndex, value) => {
    setTableData((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        birthPlaceQuery: value,
        open: true,
      };
      return updated;
    });
  };

  const handleBirthPlaceSelect = (rowIndex, item) => {
    setTableData((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        birthPlaceQuery: item.country,
        placeOfBirth: item.code,
        open: false,
      };
      return updated;
    });
    setChildGuest((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        birthPlaceQuery: item.country,
        placeOfBirth: item.code,
        provinceCode: item.province,
        birthState: resolveBirthState(item.code),
        open: false,
      };
      return updated;
    });
  };

  const handleBirthPlaceBlur = (rowIndex, filtered) => {
    setTimeout(() => {
      setTableData((prev) => {
        const updated = [...prev];
        const row = updated[rowIndex];

        const exactMatch = filtered.some(
          (item) => item.country === row.birthPlaceQuery,
        );

        updated[rowIndex] = exactMatch
          ? { ...row, open: false }
          : {
              ...row,
              birthPlaceQuery: "",
              placeOfBirth: "",
              open: false,
            };

        return updated;
      });
      validateRow(tabledata[rowIndex], rowIndex);
    }, 200);
  };

  const handleCitizenChange = (rowIndex, value) => {
    setTableData((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        citizenQuery: value,
      };
      return updated;
    });
    setOpenCitizenRow(rowIndex);
  };

  const handleCitizenSelect = (rowIndex, item) => {
    setTableData((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        citizenQuery: item.country,
        citizen: item.code,
      };
      return updated;
    });
    setChildGuest((prev) => {
      const updated = [...prev];
      updated[rowIndex] = {
        ...updated[rowIndex],
        citizenQuery: item.country,
        citizen: item.code,
        open: false,
      };
      return updated;
    });
    setOpenCitizenRow(null);
  };

  const handleCitizenBlur = (rowIndex, filtered) => {
    setTimeout(() => {
      setTableData((prev) => {
        const updated = [...prev];
        const row = updated[rowIndex];

        const exactMatch = filtered.some(
          (item) => item.country === row.citizenQuery,
        );

        updated[rowIndex] = exactMatch
          ? { ...row, open: false }
          : {
              ...row,
              citizenQuery: "",
              citizen: "",
            };

        return updated;
      });
      setOpenCitizenRow(null);
      validateRow(tabledata[rowIndex], rowIndex);
    }, 200);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await AllServices.gellAllCustomerDetailsById(
        state?.refNumber,
      );
      //set children images
      const childrenFiles = response.data.message.files;
      setChildFile(childrenFiles);

      const message = response.data.message;

      const normalizedChildren = message.childrens.map((child) => ({
        ...child,
        placeOfBirth: "",
        open: false,
      }));

      setTableData(normalizedChildren);
      setChildGuest(normalizedChildren);
      const booking = message.booking?.[0];
      if (booking) {
        const arriving = dayjs(booking.Arriving_DateTime).startOf("day");
        const departure = dayjs(booking.Depature_DateTime).startOf("day");

        setStayDays(departure.diff(arriving, "day"));
        setArrivingData(arriving);

        setMainGuest((prev) => ({
          ...prev,
          arrivingDate: booking.Arriving_DateTime.split("T")[0],
          firstName: booking.Customer_Fname || "",
          lastName: booking.Customer_Lname || "",
          sex: message.Gender || "",
          dob: message.DOB ? message.DOB.split("T")[0] : "",
          // birthState: message.Country || "",
          // citizen: message.Country || "",
        }));
      }
    } catch (error) {
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async () => {
    let isValid = true;
    tabledata.forEach((row, index) => {
      const rowValid = validateRow(row, index);

      if (!rowValid) isValid = false;
    });

    if (!isValid) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      // setLoading(true);
      const dataObj = {
        mainGuest: mainGuest,
        childGuest: childGuest,
      };
      setStoreData(dataObj);
      setOpenModal(true);

      // const response = await AllServices.passdataWebPortal(dataObj);

      // if (response.data.succuss) {
      //   toast.success(response.data.message);
      //   navigate("/admin/views/pastguest");
      // }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  const onClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();
    }, [500]);

    return () => {
      clearTimeout(handler);
    };
  }, []);

  const columns = [
    { name: "Cognome", selector: (row) => row.Fname, sortable: false },
    { name: "Nome", selector: (row) => row.Lname, sortable: false },
    {
      name: "Data di Nascita",
      selector: (row) => row.DOB?.split("T")[0],
      sortable: false,
    },
    { name: "Sesso", selector: (row) => row.Gender, sortable: false },

    {
      name: "Documento",
      cell: (child, index) => {
        const filteredFiles = childFile?.filter((file) =>
          file.Fieldname.startsWith(`guests[${index + 1}][documents]`),
        );

        return filteredFiles?.length > 0 ? (
          <div className="doc-wrapper">
            {filteredFiles.map((item) => (
              <div key={item.ID}>
                {item.FileName.endsWith(".pdf") ? (
                  <a
                    href={`${imageBaseURL}${item.FileName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="pdf-icon-containor">
                      <PictureAsPdfOutlinedIcon className="pdf-icon" />
                      <span>View PDF</span>
                    </div>
                  </a>
                ) : (
                  <a
                    href={`${imageBaseURL}${item.FileName}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${imageBaseURL}${item.FileName}`}
                      alt="Guest File"
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        borderRadius: "4px",
                        transition: "transform 0.3s",
                      }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "scale(1.2)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    />
                  </a>
                )}
              </div>
            ))}
          </div>
        ) : (
          "--"
        );
      },
    },

    {
      name: "Cittadinanza",
      cell: (row, index) => {
        const filtered = country_List
          .filter((c) =>
            c.country
              .toLowerCase()
              .startsWith((row.citizenQuery || "").toLowerCase()),
          )
          .slice(0, 20);

        return (
          <div style={{ position: "relative", width: "100%" }}>
            <input
              type="text"
              value={row.citizenQuery}
              onChange={(e) => handleCitizenChange(index, e.target.value)}
              onBlur={() => handleCitizenBlur(index, filtered)}
              style={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                width: "90%",
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                zIndex: 99999,
              }}
            />

            {rowErrors[index]?.citizen && (
              <div style={{ color: "red", fontSize: "11px" }}>
                Cittadinanza is required
              </div>
            )}

            {openCitizenRow === index && filtered.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  maxHeight: 200,
                  overflowY: "auto",
                  background: "#fff",
                  border: "1px solid #ccc",
                  zIndex: 99999,
                }}
              >
                {filtered.map((item, i) => (
                  <div
                    key={i}
                    onMouseDown={() => handleCitizenSelect(index, item)}
                    style={{ padding: "6px", cursor: "pointer" }}
                  >
                    {item.country}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      },
    },
    {
      name: "Luogo di Nascita",
      cell: (row, index) => {
        const filtered = combineList
          .filter((c) =>
            c.country
              .toLowerCase()
              .startsWith((row.birthPlaceQuery || "").toLowerCase()),
          )
          .slice(0, 20);

        return (
          <div style={{ position: "relative", width: "100%" }}>
            <input
              type="text"
              value={row.birthPlaceQuery}
              onChange={(e) => handleBirthPlaceChange(index, e.target.value)}
              onBlur={() => handleBirthPlaceBlur(index, filtered)}
              style={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                width: "90%",
                padding: "6px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                zIndex: 99999,
              }}
            />

            {rowErrors[index]?.placeOfBirth && (
              <div style={{ color: "red", fontSize: "11px" }}>
                Luogo di nascita is required
              </div>
            )}

            {row.open && filtered.length > 0 && (
              <div
                style={{
                  position: "absolute",
                  width: "100%",
                  maxHeight: 200,
                  overflowY: "auto",
                  background: "#fff",
                  border: "1px solid #ccc",
                  zIndex: 99999,
                }}
              >
                {filtered.map((item, i) => (
                  <div
                    key={i}
                    onMouseDown={() => handleBirthPlaceSelect(index, item)}
                    style={{ padding: "6px", cursor: "pointer" }}
                  >
                    {item.country}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const customStyles = {
    rows: {
      style: {
        minHeight: "64px",
        backgroundColor: "#f8f9fa",
        paddingTop: "10px",
        paddingBottom: "60px",

        "&:hover": {
          backgroundColor: "#e0e0e0",
        },
      },
    },
    headCells: {
      style: {
        backgroundColor: "#2f78bb",
        color: "#ddd",
        fontWeight: "bold",
        fontSize: "14px",
        justifyContent: "center",
        fontFamily: "Roboto",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        justifyContent: "center",
        fontFamily: "sans-serif",
        color: "#021049",
        fontSize: "14px",
        fontFamily: "Roboto",
      },
    },
  };

  return (
    <div className="webportal-table-container">
      {loading && (
        <div className="loader-overlay">
          <CustomLoaderBoxy />
        </div>
      )}

      {openModal && (
        <div className="loader-overlay">
          <WpConfirmationTable data={storeData} onClose={onClose} />
        </div>
      )}
      <div className="webportal-table-wrapper">
        <h2>Inserimento On-Line Ospiti</h2>

        <div className="infinite-line"></div>

        <div className="txt-containor">
          <span>Tipo Alloggiato : {guestTypeName}</span>
          <span>
            Data di Arrivo :{" "}
            <span className="txt-details">
              {arrivingdate ? arrivingdate.format("YYYY-MM-DD") : ""}
            </span>
          </span>
          <span>
            Permanenza : <span className="txt-details">{stayDays}</span>
          </span>
        </div>

        <div className="table-containor">
          <DataTable
            columns={columns}
            data={tabledata}
            customStyles={customStyles}
            pagination
            className="my-table"
          />
        </div>

        <div className="button-group-step2">
          <button className="btn btn-blue" onClick={handleClick}>
            confermare
          </button>
        </div>
      </div>
    </div>
  );
};

export default WpDashboardStep;
